export default __webpack_public_path__ + "static/media/Background_Header_SVG.bd5cd253.svg";